/**
 * @generated SignedSource<<4b03d1ad9b7dc50ff0f510b0e64268cd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AuctionItemPriceDetailsLazy_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AuctionItemPriceDetails_item">;
  readonly " $fragmentType": "AuctionItemPriceDetailsLazy_item";
};
export type AuctionItemPriceDetailsLazy_item$key = {
  readonly " $data"?: AuctionItemPriceDetailsLazy_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"AuctionItemPriceDetailsLazy_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "page"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AuctionItemPriceDetailsLazy_item",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "page"
        }
      ],
      "kind": "FragmentSpread",
      "name": "AuctionItemPriceDetails_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "7a40e5da6f005068b325a967fa461b3e";

export default node;
